module.exports = __webpack_public_path__ + "static/media/ci.060b34c4.svg";